import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { XC_URL } from '../../config';
import { 
	Radio,
	RadioGroup,
	FormControlLabel,
	withStyles,
	Button,
	Grid,
	IconButton,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Link,
	Typography
} from '@material-ui/core';
import { addMLSConnectionWithAgentId, addMLSConnectionWithOfficeId, clearConnectMlsState } from 'redux/modules/mls';
import FormHelperText from '@material-ui/core/FormHelperText';
import classNames from 'classnames';
import ValidationSchema from './AddMlsConnectionModalSchema';
import { hideModal, resetModal } from 'redux/modules/modal';
import { showErrorPopup } from 'redux/modules/companies';
import ReactSelect from '../../components/ReactSelect';
import { sendConnectMlsRequest, sendMlsReviewRequest } from 'redux/modules/mls';
import { sendVerifyAccountEmail } from 'redux/modules/account';

import PropTypes from 'prop-types';
import FormField from '../FormField';
import { XIcon, SpinnerIcon, IconTickRounded, IconErrorRounded, IconInfoRounded } from '../../theme/icons';
import _ from 'lodash';
import ERRORS from '../../errors/errorids';
import { 
	trackAddMlsConnectionPopupShown,
	trackConnectedMlsWithOfficeIdSuccess,
	trackConnectedMlsWithAgentIdSuccess,
	trackSentConnectionRequestToXaraSuccess,
	trackSentReviewMlsToXaraSuccess,
	trackConnectedMlsWithOfficeIdFailure,
	trackConnectedMlsWithAgentIdFailure,
	trackSentConnectionRequestToXaraFailure,
	trackSentReviewMlsToXaraFailure,
} from 'lib/Segment/customTrackers';

import { getTrackingOptions } from 'lib/Segment/helpers';
import { openIntercomChat } from 'utils/intercom';
import { getMlsFormProps } from 'utils/forms';
import { MLS_ERRORS } from 'utils/mls';

import i18n from 'i18n/i18n';
const localize = i18n.loc.localize;

const SCREEN_TYPE = {
	MLS_API: 'MLS_API',
	MLS_CUSTOM: 'MLS_CUSTOM',
	MLS_AGENT_ID_REVIEW_NEEDED: 'MLS_AGENT_ID_REVIEW_NEEDED',
	MLS_OFFICE_ID_REVIEW_NEEDED: 'MLS_OFFICE_ID_REVIEW_NEEDED'
};

const CONNECT_WITH = {
	MLS_OFFICE_ID: 'MLS_OFFICE_ID',
	AGENT_MLS_ID: 'AGENT_MLS_ID',
};

const styles = theme => {
	return {
		...getMlsFormProps(theme),

		/* Dialog */
		dialogPaper: {
			minWidth: 444
		},
		dialogWrapper: {
			position: 'relative',
			padding: '15px 10px 0',
			minHeight: 535,
			display: 'flex',
			flexDirection: 'column'
		},
		
		/* loading icon */
		loadingContainer: {
			minHeight: 535,
			position: 'relative'
		},

		/* autoCompleteComponent */
		autoCompleteComponent: {
		},

		optionAgentId: {
			margin: '0 70px 0 -8px'
		}
	};
};

@withStyles(styles)
class InviteUserModal extends Component {

	constructor(props) {
		super(props);

		this.state = {
			currentStep: SCREEN_TYPE.MLS_API,
			connectWith: CONNECT_WITH.AGENT_MLS_ID,
			mlsOfficeId: '',
			agentMlsId: '',
			mlsSystem: null,
			mlsSystemCustom: null,
			listingMlsNumber: '',

			xhrInProgress: false,
			apiRequestSuccess: false,
			apiRequestError: false,
			errors: {},
			touched: {}
		};

		this.handleMlsNotInTheList = this.handleMlsNotInTheList.bind(this);
		this.handleOpenIntercom = this.handleOpenIntercom.bind(this);
	}

	render() {
		const { modalShown, resetModal, classes } = this.props;

		return (
			<Dialog
				open={modalShown}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				onExited={resetModal}
				BackdropProps={{ style: { backgroundColor: 'rgba(46, 63, 79, 0.4)' } }}
				classes={{ paper: classes.dialogPaper }}
				PaperProps={{
					style: {
						border: 0,
						width: 309,
						minWidth: 505,
						borderRadius: 5,
						boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.08)'
					}
				}}
			>
				<div className={classes.dialogWrapper}>
					{!this.state.xhrInProgress && (
						<IconButton
							className={classes.closeDialog}
							component='span'
							aria-label='Close'
							onClick={() => this.closeDialog()}
						>
							<XIcon className={classes.closeDialogIcon} />
						</IconButton>
					)}
					
					{(() => {
						if (this.state.xhrInProgress) {
							return this.renderLoading();
						} else if (
							[SCREEN_TYPE.MLS_AGENT_ID_REVIEW_NEEDED,
								SCREEN_TYPE.MLS_OFFICE_ID_REVIEW_NEEDED].includes(this.state.currentStep)) {
							return this.props.mls.reviewMlsSuccess
								?
								this.renderSuccess()
								:
								this.renderReviewMlsId();
						} else if (this.state.apiRequestSuccess) {
							return this.renderSuccess();
						} else if (this.state.apiRequestError) {
							return this.state.currentStep === SCREEN_TYPE.MLS_CUSTOM ? this.renderForm() : this.renderFailure();
						} else {
							return this.renderForm();
						}
					})()}
				</div>
			</Dialog>
		);
	}

	closeDialog() {
		const shouldReloadList = this.state.apiRequestSuccess && this.state.currentStep === SCREEN_TYPE.MLS_API;
		this.props.onClose(shouldReloadList);
	}

	backToForm() {
		this.props.clearConnectMlsState();
		this.setState({
			currentStep: SCREEN_TYPE.MLS_API,
			xhrInProgress: false,
			apiRequestSuccess: false,
			apiRequestError: false,
			errors: {}
		});
	}

	renderLoading() {
		const { classes } = this.props;
		return (
			<div className={classes.loadingContainer}>
				<div className={classes.loadingContent}>
					<SpinnerIcon className={classes.loadingIcon} />
					<Typography className={classes.loadingMessage} variant="body2">
						{localize('mls-popup-saving-form')}
					</Typography>
				</div>
			</div>
		);
	}

	renderSuccess() {
		const { classes } = this.props;

		return (
			<Fragment>
				<DialogTitle
					variant='body1'
					color='default'
					className={classes.dialogTitle}>
					<IconTickRounded className={classes.headerIcon} /> {
						localize(
						[SCREEN_TYPE.MLS_CUSTOM,
							SCREEN_TYPE.MLS_AGENT_ID_REVIEW_NEEDED,
							SCREEN_TYPE.MLS_OFFICE_ID_REVIEW_NEEDED].includes(this.state.currentStep)
							? 'mls-request-success-screen-title' : 'mls-connection-success-screen-title')
					}
				</DialogTitle>
				<DialogContent className={classes.dialogContent} >
					<Grid container direction="column">

						<Grid item className={classNames(classes.successMessage, classes.feedbackMessage)}>
							<Typography
								variant="body2"
								dangerouslySetInnerHTML={{ __html: 
									localize(
										[SCREEN_TYPE.MLS_CUSTOM,
											SCREEN_TYPE.MLS_AGENT_ID_REVIEW_NEEDED,
											SCREEN_TYPE.MLS_OFFICE_ID_REVIEW_NEEDED].includes(this.state.currentStep)
											?
											'mls-request-success-screen-description'
											:
											'mls-connection-success-screen-description')
								}} />
						</Grid>

					</Grid>
				</DialogContent>
				<DialogActions>
					<Grid
						item
						container
						direction="row"
						justify="flex-end"
						className={classes.buttonsContainer}>

						{
							this.state.currentStep === SCREEN_TYPE.MLS_API && (
								<Button
									variant='contained'
									color='primary'
									data-tid="button-run-playbooks"
									className={classNames(classes.button, classes.buttonPrimary)}
									onClick={() => this.runPlaybooks()}
								>
									{localize('mls-connection-success-screen-run-playbooks')}
								</Button>
							)
						}

						{
							[SCREEN_TYPE.MLS_CUSTOM,
								SCREEN_TYPE.MLS_AGENT_ID_REVIEW_NEEDED,
								SCREEN_TYPE.MLS_OFFICE_ID_REVIEW_NEEDED].includes(this.state.currentStep) &&
							(
								<Button
									variant='contained'
									color='primary'
									data-tid="button-close-dialog"
									className={classNames(classes.button, classes.buttonPrimary)}
									onClick={() => this.closeDialog()}
								>
									{localize('mls-request-success-screen-got-it')}
								</Button>
							)
						}

					</Grid>
				</DialogActions>
			</Fragment>
		);		
	}

	renderFailure() {
		const { classes } = this.props;

		const errors = this.state.errors;
		const apiError = _.get(errors, 'apiError');

		const headerIcon = <IconErrorRounded className={classes.headerIcon} />;
		const popupTitle = localize('mls-error-connection-screen-title');

		return (
			<Fragment>
				<DialogTitle
					variant='body1'
					color='default'
					className={classes.dialogTitle}>
					{headerIcon} {popupTitle}
				</DialogTitle>
				<DialogContent className={classes.dialogContent} >
					<Grid container direction="column">
						<Grid item className={classNames(classes.failureMessage, classes.feedbackMessage)}>
							
							<Typography
								variant="body2"
								dangerouslySetInnerHTML={{ __html: apiError }} />


							{_.get(this.props.mls, 'addConnectionWithOfficeIdErrorId' !== ERRORS.MLS_NO_LISTINGS_FOUND) &&
								this.renderContactForHelp()}
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions>
					<Grid
						item
						container
						direction="row"
						justify="flex-end"
						className={classes.buttonsContainer}>

						<Button
							variant='outlined'
							color='primary'
							data-tid="button-back-to-form"
							className={classNames(classes.button, classes.buttonBack)}
							onClick={() => this.backToForm()}
						>
							{localize('mls-error-screen-back')}
						</Button>
						<Button
							variant='contained'
							color='primary'
							data-tid="button-close-dialog"
							className={classNames(classes.button, classes.buttonPrimary)}
							onClick={() => this.closeDialog()}
						>
							{localize('mls-error-screen-close')}
						</Button>
					</Grid>
				</DialogActions>
			</Fragment>
		);		
	}	

	renderReviewMlsId() {
		const { classes } = this.props;
		const headerIcon = <IconInfoRounded className={classNames(classes.headerIcon, classes.headerIconInfo)} />;
		const popupTitle = localize('mls-error-connection-screen-title-no-listings-found');

		const errorMessage = this.state.currentStep === SCREEN_TYPE.MLS_OFFICE_ID_REVIEW_NEEDED
			?
			localize('mls-popup-no-listings-found-for-office-id', [this.state.mlsSystem.label, this.state.mlsOfficeId])
			:
			localize('mls-popup-no-listings-found-for-agent-id', [this.state.mlsSystem.label, this.state.agentMlsId]);

		return (
			<Fragment>
				<DialogTitle
					variant='body1'
					color='default'
					className={classes.dialogTitle}>
					{headerIcon} {popupTitle}
				</DialogTitle>
				<DialogContent className={classes.dialogContent} >
					<Grid container direction="column">
						{Object.keys(this.state.errors).length > 0 && this.renderErrorMessage()}
						<Grid item className={classNames(classes.failureMessage, classes.feedbackMessage)}>
							<Typography
								variant="body2"
								dangerouslySetInnerHTML={{ __html: errorMessage }} />

							{_.get(this.props.mls, 'reviewMlsErrorId') && this.renderContactForHelp()}
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions>
					<Grid
						item
						container
						direction="row"
						justify="flex-end"
						className={classes.buttonsContainer}>

						<Button
							variant='outlined'
							color='primary'
							data-tid="button-back-to-form"
							className={classNames(classes.button, classes.buttonBack)}
							onClick={() => this.backToForm()}
						>
							{localize('mls-error-screen-back')}
						</Button>
						<Button
							variant='contained'
							color='primary'
							data-tid="button-send-to-review-office-id"
							className={classNames(classes.button, classes.buttonPrimary)}
							onClick={() => this.sendToReview()}
						>
							{localize('mls-error-screen-send-to-review')}
						</Button>
					</Grid>
				</DialogActions>
			</Fragment>
		);		
	}		

	renderErrorMessage() {
		const errors = this.state.errors;
		const apiError = _.get(errors, 'apiError');
		const formError = this.hasFormError(errors) && 'mls-popup-errors-found-in-the-form';
		
		let errorMessageKey;
		if (this.state.errors.mlsBoardListError) {
			errorMessageKey = 'mls-connection-popup-error-failed-to-load-mls-board-list';
		} else if (formError) {
			errorMessageKey = formError;
		} else if (apiError) {
			errorMessageKey = apiError;
		}
		const { classes } = this.props;
		return (
			<Typography
				className={classes.errorMessage}
				variant="body2"
				dangerouslySetInnerHTML={{ __html: localize(errorMessageKey) }}
			/>
		);		
	}

	renderContactForHelp() {
		return (
			<Typography variant="body2">
				<Link onClick={this.handleOpenIntercom}>
					{localize('mls-error-screen-contact-for-help-1')}
				</Link>&nbsp;
				{localize('mls-error-screen-contact-for-help-2')}
			</Typography>		
		);
	}

	handleMlsNotInTheList() {
		this.setState({
			agentMlsId: '',
			listingMlsNumber: '',
			currentStep: SCREEN_TYPE.MLS_CUSTOM,
			errors: {}
		});
	}

	handleOpenIntercom() {
		openIntercomChat(null, true, this.props.showErrorPopup);
	}

	handleConnectWithChange(event) {
		const newState = { 
			connectWith: event.target.value,
			errors: {}
		};

		if (this.props.mls.mlsBoardListFailedToLoad) {
			newState.errors.mlsBoardListError = true;
		}

		this.setState(newState);
	}

	renderForm() {
		const { classes } = this.props;
		const { mlsOfficeId, agentMlsId, mlsSystem, mlsSystemCustom, listingMlsNumber } = this.state;
		const errorClasses = { error: classes.error };

		return (
			<Fragment>
				<DialogTitle
					variant='body1'
					color='default'
					className={classes.dialogTitle}>
					{localize(
							this.state.currentStep === SCREEN_TYPE.MLS_CUSTOM
								?
								'custom-mls-connection-popup-header'
								:
								'mls-connection-popup-header'
					)}
				</DialogTitle>
				<DialogContent className={classes.dialogContent} >
					<Grid container direction="column">
						{Object.keys(this.state.errors).length > 0 && this.renderErrorMessage()}
						{(this.state.currentStep === SCREEN_TYPE.MLS_API) && (
							<Fragment>
								<Grid
									item
									className={classNames({
										[classes.textFieldWrapper]: true,
										[classes.textFieldWrapperError]: this.state.errors['mlsSystem'],
									})}
								>
									<Typography className={classes.formFieldLabel} variant="body1">
										{localize('your-mls-label')}
									</Typography>
									<ReactSelect 
										value={_.get(mlsSystem, 'value') === '' ? null /* shows placeholder */ : mlsSystem}
										options={this.props.mls.mlsBoardList.map(item =>
											({ label: item.displayName, value: item.mlsBoardCode }))}
										className={classes.autoCompleteComponent}
										placeholder={localize('your-mls-placeholder')} 
										isDisabled={this.props.mls.mlsBoardListFailedToLoad === true}
										onChangeHandler={(newValue) => {
											this.onAutocompleteFieldChange(newValue, 'mlsSystem');
										}}
									/>
									{ this.state.errors['mlsSystem'] &&
										<FormHelperText error={true} classes={errorClasses}>
											{this.state.errors['mlsSystem']}
										</FormHelperText>
									}
								</Grid>						

								<Grid item className={classes.radioGroupContainer}>
									<Typography
										className={classNames(classes.formFieldLabel, classes.radioGroupLabel)}
										variant="body1">
										{localize('mls-connect-with-label')}
									</Typography>									
									<RadioGroup
										name="connectOptions"
										data-tid='connect-options'
										value={this.state.connectWith}
										row={true}
										onChange={(event) => this.handleConnectWithChange(event)}
									>
										<FormControlLabel
											value={CONNECT_WITH.AGENT_MLS_ID}
											className={classNames(
												classes.optionAgentId,
												classes.noMargins,
												this.state.connectWith === CONNECT_WITH.AGENT_MLS_ID ?
													classes.radioSelectorLabelChecked : classes.radioSelectorLabel,
												classes.radioSelectorLabelHover)}
											control={
												<Radio
													color="primary"
													className={classes.radioButton}
													disableRipple
												/>}
											label={localize('mls-agent-id-label')} />

										<FormControlLabel
											value={CONNECT_WITH.MLS_OFFICE_ID}
											className={classNames(
												classes.noMargins,
												this.state.connectWith === CONNECT_WITH.MLS_OFFICE_ID ?
													classes.radioSelectorLabelChecked : classes.radioSelectorLabel,
												classes.radioSelectorLabelHover)}
											control={
												<Radio
													color="primary"
													className={classes.radioButton}
													disableRipple
												/>}
											label={localize('mls-office-id-label')} />
									</RadioGroup>
								</Grid>

								{
									this.state.connectWith === CONNECT_WITH.MLS_OFFICE_ID && (
										<Grid item className={classes.textFieldWrapper}>
											{this.textField(
													'mlsOfficeId',
													mlsOfficeId,
													localize('mls-office-id-placeholder'),
													null,
													null,
													null,
													false
											)}
										</Grid>
									)
								}
								{
									this.state.connectWith === CONNECT_WITH.AGENT_MLS_ID && (
										<Grid item className={classes.textFieldWrapper}>
											{this.textField(
													'agentMlsId',
													agentMlsId,
													localize('mls-agent-id-placeholder'),
													null,
													null,
													null,
													false
											)}
										</Grid>
									)
								}
							</Fragment>
						)}

						{(this.state.currentStep === SCREEN_TYPE.MLS_CUSTOM) && (
							<Fragment>
								<Grid item className={classes.textFieldWrapper}>
									<Typography className={classes.formFieldLabel} variant="body1">
										{localize('your-mls-label')}
									</Typography>
									{this.textField(
											'mlsSystemCustom',
											mlsSystemCustom,
											localize('mls-office-other-placeholder'),
											null,
											null,
											null,
											false
									)}
								</Grid>						
								<Grid item className={classes.textFieldWrapper}>
									<Typography className={classes.formFieldLabel} variant="body1">
										{localize('mls-office-id-label')}
									</Typography>
									{this.textField(
											'mlsOfficeId',
											mlsOfficeId,
											localize('mls-office-id-placeholder'),
											null,
											null,
											null,
											false
									)}
								</Grid>
								<Grid item className={classes.textFieldWrapper}>
									<Typography className={classes.formFieldLabel} variant="body1">
										{localize('mls-listing-number-label')}
									</Typography>
									{this.textField(
											'listingMlsNumber',
											listingMlsNumber,
											localize('mls-listing-number-placeholder'),
											null,
											null,
											null,
											false
									)}
								</Grid>
							</Fragment>
						)}

						{(this.state.currentStep === SCREEN_TYPE.MLS_API) && (
							<Grid item className={classes.linksContainer}>
								<Typography variant="body1" className={classes.link}>
									<Link onClick={this.handleMlsNotInTheList}>
										{localize('mls-connection-popup-mls-not-in-the-list')}
									</Link>
								</Typography>
								<Typography variant="body1" className={classes.link}>
									<Link onClick={this.handleOpenIntercom}>
										{localize('mls-popup-contact-us')}
									</Link>
								</Typography>
							</Grid>							
						)}
					</Grid>
				</DialogContent>
				<DialogActions>
					<Grid item container direction="row" justify="flex-end" className={classes.buttonsContainer}>
						<Button
							variant='contained'
							color='primary'
							data-tid="button-connect-mls"
							className={classNames(classes.button, classes.buttonPrimary)}
							onClick={() => this.submitForm()}
							disabled={Object.keys(this.getFormErrors(true)).length > 0}>
							{localize(
								this.state.xhrInProgress
									?
									'mls-popup-sending-request'
									:
									this.state.currentStep === SCREEN_TYPE.MLS_CUSTOM
										?
										'mls-popup-submit-request'
										:
										'mls-popup-connect')
							}
						</Button>
					</Grid>
				</DialogActions>
			</Fragment>
		);
	}

	runPlaybooks() {
		window.open(`${XC_URL}?viewID=PLAYBOOK_RUNS`, '_blank');
	}

	async submitForm(forceAddition = false) {
		this.setState({ 
			xhrInProgress: true,
			apiRequestError: false,
			apiRequestSuccess: false,
			errors: { apiError: null }
		});

		if (this.state.currentStep === SCREEN_TYPE.MLS_CUSTOM) {
			this.props.sendConnectMlsRequest(
				{
					'user-email': _.get(this.props.user, 'mainEmail'),
					'user-xc-id': _.get(this.props.user, 'userId'),
					'mls-system': this.state.mlsSystemCustom,
					'listing-mls-number': this.state.listingMlsNumber,
					'mls-office-id': this.state.mlsOfficeId,
					'process-activate-playbooks': 1
				});

		} else if (this.state.currentStep === SCREEN_TYPE.MLS_API) {
			if (this.state.connectWith === CONNECT_WITH.MLS_OFFICE_ID) {

				this.props.addMLSConnectionWithOfficeId(
					_.get(this.state.mlsSystem, 'value'),
					this.state.mlsOfficeId,
					forceAddition
				);
		
			} else if (this.state.connectWith === CONNECT_WITH.AGENT_MLS_ID) {

				this.props.addMLSConnectionWithAgentId(
					_.get(this.state.mlsSystem, 'value'),
					this.state.agentMlsId,
				);

			}
		}		
	}

	async sendToReview() {
		this.setState({ 
			xhrInProgress: true,
			apiRequestError: false,
			apiRequestSuccess: false,
			errors: { apiError: null }
		});

		this.props.sendMlsReviewRequest(
			{
				'user-email': _.get(this.props.user, 'mainEmail'),
				'user-xc-id': _.get(this.props.user, 'userId'),
				'mls-system': this.state.mlsSystem.label,
				'mls-agent-id': this.state.agentMlsId || '-',
				'mls-office-id': this.state.mlsOfficeId || '-',
				'process-review': 1
			}
		);
	}

	isSubmitEnabled() {
		return !this.hasFormError(this.state.errors) ||
		Object.keys(this.state.errors).length === 1 && _.get(this.state, 'errors.apiError');
	}

	hasFormError(errorState) {
		let result = false;

		Object.keys(errorState).forEach(fieldName => {
			if (fieldName.indexOf('mlsOfficeId') !== -1 ||
				fieldName.indexOf('agentMlsId') !== -1 ||
				fieldName.indexOf('mlsSystemCustom') !== -1 ||
				fieldName.indexOf('mlsSystem') !== -1) {
				result = true;
			}
		});

		return result;
	}

	componentDidMount() {
		trackAddMlsConnectionPopupShown(getTrackingOptions(this.props.company));

		if (this.props.mls.mlsBoardListFailedToLoad) {
			this.setState({
				errors: { mlsBoardListError: true }
			});			
		}				
	}

	componentWillReceiveProps(nextProps) {
		if (
			(
				this.props.mls.reviewMlsErrorId !== nextProps.mls.reviewMlsErrorId &&
				nextProps.mls.reviewMlsErrorId !== null				
			) || (
				this.props.mls.connectMlsErrorId !== nextProps.mls.connectMlsErrorId &&
				nextProps.mls.connectMlsErrorId !== null				
			) || (
				this.props.mls.addConnectionWithOfficeIdErrorId !== nextProps.mls.addConnectionWithOfficeIdErrorId &&
					nextProps.mls.addConnectionWithOfficeIdErrorId !== null
			) || (
				this.props.mls.addConnectionWithAgentIdErrorId !== nextProps.mls.addConnectionWithAgentIdErrorId &&
					nextProps.mls.addConnectionWithAgentIdErrorId !== null
			)
		) {
			this.handleApiErrors(nextProps);

			if (nextProps.mls.reviewMlsErrorId) {
				trackSentReviewMlsToXaraFailure(getTrackingOptions(this.props.company));
				
			} else if (nextProps.mls.addConnectionWithOfficeIdErrorId) {
				trackConnectedMlsWithOfficeIdFailure(getTrackingOptions(this.props.company));

			} else if (nextProps.mls.addConnectionWithAgentIdErrorId) {
				trackConnectedMlsWithAgentIdFailure(getTrackingOptions(this.props.company));
			
			} else if (nextProps.mls.connectMlsErrorId) {
				trackSentConnectionRequestToXaraFailure(getTrackingOptions(this.props.company));
			}

		}		

		if (
			(
				this.props.mls.addConnectionWithOfficeIdErrorId !== nextProps.mls.addConnectionWithOfficeIdErrorId &&
					nextProps.mls.addConnectionWithOfficeIdErrorId === ERRORS.EMAIL_NOT_VERIFIED
			) || (
				this.props.mls.addConnectionWithAgentIdErrorId !== nextProps.mls.addConnectionWithAgentIdErrorId &&
					nextProps.mls.addConnectionWithAgentIdErrorId === ERRORS.EMAIL_NOT_VERIFIED
			)
		) {
			this.props.sendVerifyAccountEmail(_.get(this.props.user, 'mainEmail'));
		}
			
		if ((this.props.mls.reviewMlsSuccess !== nextProps.mls.reviewMlsSuccess && nextProps.mls.reviewMlsSuccess === true) || 
			(this.props.mls.connectMlsSuccess !== nextProps.mls.connectMlsSuccess && nextProps.mls.connectMlsSuccess === true) || 
			(this.props.mls.addConnectionWithOfficeIdSuccess !== nextProps.mls.addConnectionWithOfficeIdSuccess &&
				nextProps.mls.addConnectionWithOfficeIdSuccess === true) || 
			(this.props.mls.addConnectionWithAgentIdSuccess !== nextProps.mls.addConnectionWithAgentIdSuccess &&
				nextProps.mls.addConnectionWithAgentIdSuccess === true)
		) {

			if (nextProps.mls.reviewMlsSuccess) {
				trackSentReviewMlsToXaraSuccess(getTrackingOptions(this.props.company));

			} else if (nextProps.mls.addConnectionWithOfficeIdSuccess) {
				trackConnectedMlsWithOfficeIdSuccess(getTrackingOptions(this.props.company));

			} else if (nextProps.mls.addConnectionWithAgentIdSuccess) {
				trackConnectedMlsWithAgentIdSuccess(getTrackingOptions(this.props.company));

			} else if (nextProps.mls.connectMlsSuccess) {
				trackSentConnectionRequestToXaraSuccess(getTrackingOptions(this.props.company));
			}

			this.setState({
				xhrInProgress: false,
				apiRequestError: false,
				apiRequestSuccess: true,
				errors: { apiError: null }
			});			
		}		
	}

	handleApiErrors(nextProps) {
		let errorMessageKey;
		let errorMessage;

		if (nextProps.mls.reviewMlsErrorId) {
			errorMessageKey = nextProps.mls.reviewMlsErrorId &&
				MLS_ERRORS[nextProps.mls.reviewMlsErrorId] || 
				MLS_ERRORS[ERRORS.UNKNOWN];

		} else if (nextProps.mls.connectMlsErrorId) {
			errorMessageKey = nextProps.mls.connectMlsErrorId &&
				MLS_ERRORS[nextProps.mls.connectMlsErrorId] || 
				MLS_ERRORS[ERRORS.UNKNOWN];
		
		} else if (nextProps.mls.addConnectionWithOfficeIdErrorId) {
			errorMessageKey = nextProps.mls.addConnectionWithOfficeIdErrorId &&
				MLS_ERRORS[nextProps.mls.addConnectionWithOfficeIdErrorId] || 
				MLS_ERRORS[ERRORS.UNKNOWN];

		} else if (nextProps.mls.addConnectionWithAgentIdErrorId) {
			errorMessageKey = nextProps.mls.addConnectionWithAgentIdErrorId &&
				MLS_ERRORS[nextProps.mls.addConnectionWithAgentIdErrorId] || 
				MLS_ERRORS[ERRORS.UNKNOWN];
		}

		if (this.state.currentStep === SCREEN_TYPE.MLS_API &&
			this.state.connectWith === CONNECT_WITH.MLS_OFFICE_ID &&
			nextProps.mls.addConnectionWithOfficeIdErrorId === ERRORS.MLS_NO_LISTINGS_FOUND) {

			this.setState({
				xhrInProgress: false,
				apiRequestError: false,
				apiRequestSuccess: false,
				currentStep: SCREEN_TYPE.MLS_OFFICE_ID_REVIEW_NEEDED,
				errors: {}
			});

		} else if (this.state.currentStep === SCREEN_TYPE.MLS_API &&
			this.state.connectWith === CONNECT_WITH.AGENT_MLS_ID &&
			nextProps.mls.addConnectionWithAgentIdErrorId === ERRORS.MLS_NO_LISTINGS_FOUND) {
			
			this.setState({
				xhrInProgress: false,
				apiRequestError: false,
				apiRequestSuccess: false,
				currentStep: SCREEN_TYPE.MLS_AGENT_ID_REVIEW_NEEDED,
				errors: {}
			});

		} else {
			errorMessage = localize(errorMessageKey);

			this.setState({
				xhrInProgress: false,
				apiRequestError: true,
				apiRequestSuccess: false,
				errors: { apiError: errorMessage }
			});
		}
	}		

	textField(name, value, placeholder, disabled, type, maxLength, autosize) {
		const { classes } = this.props;

		return (
			<FormField
				value={value}
				autoComplete='off'
				className={classes.field}
				data-tid={`form-user-${name}`}
				onChange={event => this.onTextFieldChange(event, name)}
				onBlur={event => this.onTextFieldBlur(event, name)}
				onKeyPress={event => this.onTextFieldKeyPress(event, name)}
				id={name}
				placeholder={placeholder}
				{...(type ? { type } : {})}
				{...(autosize ? { autosize } : {})}
				margin="normal"
				helperText={this.state.errors[name]}
				error={!!this.state.errors[name]}
				disabled={disabled}
				maxLength={maxLength}
				inputRef={this[name]}
			/>
		);
	}

	onAutocompleteFieldChange(newValue, name) {
		this.setState({ [name]: newValue });
		this.setFieldState(name, newValue);
	}

	onTextFieldBlur(event, name) {
		let newState = _.cloneDeep(this.state);
		newState.touched[name] = true;
		this.setState(newState, this.validateAll);
	}	

	onTextFieldKeyPress(event, name) {
		if (!this.isSubmitEnabled()) return;
		if (event.key === 'Enter') {
			this.submitForm();
		}
	}

	onTextFieldChange(event, name) {
		this.setFieldState(name, event.target.value);
	}

	setFieldState(fieldName, value) {
		this.setState({ [fieldName]: value });

		let newState = _.cloneDeep(this.state);
		newState.touched[fieldName] = true;
		newState[fieldName] = value;
		this.setState(newState, this.validateAll);
	}

	getFormErrors(includeAllField) {
		// includeAllField - include all fields in validation, not only touched
		let validateFields = null;

		if (this.state.currentStep === SCREEN_TYPE.MLS_CUSTOM) {
			validateFields = ['mlsSystemCustom', 'mlsOfficeId'];

		} else if (this.state.currentStep === SCREEN_TYPE.MLS_API) {
			if (this.state.connectWith === CONNECT_WITH.MLS_OFFICE_ID) {
				validateFields = ['mlsSystem', 'mlsOfficeId'];

			} else if (this.state.connectWith === CONNECT_WITH.AGENT_MLS_ID) {
				validateFields = ['mlsSystem', 'agentMlsId'];
				
			}
		}

		let foundErrors = {};
		for (let field in ValidationSchema) {
			if (validateFields.includes(field)) {
				let validate = ValidationSchema[field];
				if (validate) {
					let error = validate(this.state[field], this.state, includeAllField);
					if (error) {
						foundErrors[field] = error;
					}
				}
			}
		}
		return foundErrors;
	}

	validateAll() {
		this.setState({ errors: this.getFormErrors(false) });
	}
}

InviteUserModal.propTypes = {
	companies: PropTypes.object,
	mls: PropTypes.object,
	modalShown: PropTypes.bool,
	hideModal: PropTypes.func,
	resetModal: PropTypes.func,
	classes: PropTypes.object,
	email: PropTypes.string,
	showApiError: PropTypes.bool,
	company: PropTypes.object,
	user: PropTypes.object.isRequired,
	showErrorPopup: PropTypes.func.isRequired,
	sendConnectMlsRequest: PropTypes.func,
	sendMlsReviewRequest: PropTypes.func,
	sendVerifyAccountEmail: PropTypes.func,
	selectedCompanyId: PropTypes.string,
	addMLSConnectionWithAgentId: PropTypes.func.isRequired,
	addMLSConnectionWithOfficeId: PropTypes.func.isRequired,
	clearConnectMlsState: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
	company: state.companies.rawDataById ? state.companies.rawDataById[state.companies.selectedId] : null,
	modalShown: state.modal.modalShown,
	companies: state.companies,
	mls: state.mls,
	user: state.session.user,
	selectedCompanyId: state.companies.selectedId,
});

const mapDispatchToProps = dispatch => bindActionCreators({
	hideModal,
	resetModal,
	showErrorPopup,
	sendConnectMlsRequest,
	sendMlsReviewRequest,
	sendVerifyAccountEmail,
	addMLSConnectionWithAgentId,
	addMLSConnectionWithOfficeId,
	clearConnectMlsState
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(InviteUserModal);


// WEBPACK FOOTER //
// ./src/components/Modal/AddMlsConnectionModal.js